import React, { Fragment } from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import Button from './Button'
import Divider from './Divider'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 40px;
`

export const LINKS = [
  {
    step: 1,
    label: 'Enter monthly costs',
    url: '/monthly-costs',
  },
  {
    step: 2,
    label: 'Enter one-time costs',
    url: '/one-time-costs',
  },
  {
    step: 3,
    label: 'Review your results & plan',
    url: '/results',
  },
]

export default () => (
  <Container>
    {_.map(LINKS, ({ url, label, step }, index) => (
      <Fragment key={url}>
        <Button to={url} step={step}>
          {label}
        </Button>
        {index < LINKS.length - 1 && <Divider />}
      </Fragment>
    ))}
  </Container>
)
